import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=66bb0087&scoped=true&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb0087",
  null
  
)

export default component.exports